var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10162IconServiceCognitiveServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f78f5115-be88-4d44-b34e-3f6ea743125c",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b6c43bd9-e37f-4191-93c2-d3a7a84c505e",
    x1: 9,
    y1: 19.13,
    x2: 9,
    y2: -0.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1380da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3c91e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#559cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea0ef"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-machinelearning-162") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,11.38A4,4,0,0,0,14.49,7.5,5.1,5.1,0,0,0,9.24,2.62,5.25,5.25,0,0,0,4.22,6,4.8,4.8,0,0,0,0,10.67a4.9,4.9,0,0,0,5.07,4.71l.44,0h8.21a.78.78,0,0,0,.22,0A4.1,4.1,0,0,0,18,11.38Z",
    fill: "url(#b6c43bd9-e37f-4191-93c2-d3a7a84c505e)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42,10.39H4.54a1.09,1.09,0,1,0,0,.49h.88a.2.2,0,0,1,.2.2v4.3h.49v-4.3A.69.69,0,0,0,5.42,10.39Zm-1.95.88a.64.64,0,1,1,.64-.64A.64.64,0,0,1,3.47,11.27Z",
    fill: "#9cebff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94,10.61v-1a.7.7,0,0,0-.7-.7H6.69a.2.2,0,0,1-.2-.2V3.4l-.23.12L6,3.66v5a.69.69,0,0,0,.69.69H8.24a.21.21,0,0,1,.21.21v1a1.08,1.08,0,0,0-.85,1.06,1.09,1.09,0,1,0,1.34-1.06Zm-.25,1.7h0a.64.64,0,1,1,.64-.64A.64.64,0,0,1,8.69,12.31Z",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.53,8.5a1.09,1.09,0,0,0-.25,2.15v.2a.21.21,0,0,1-.21.21h-2V7.54a.69.69,0,0,0-.69-.69H10.35A1.08,1.08,0,0,0,9.29,6a1.09,1.09,0,1,0,1.06,1.34h1.07a.2.2,0,0,1,.2.2v7.84h.49V11.55h2a.7.7,0,0,0,.7-.7v-.2a1.09,1.09,0,0,0,.85-1.06h0A1.09,1.09,0,0,0,14.53,8.5ZM9.29,7.73h0a.64.64,0,1,1,.64-.64A.64.64,0,0,1,9.29,7.73Zm5.24,2.5h0a.64.64,0,1,1,.63-.64A.64.64,0,0,1,14.53,10.23Z",
    fill: "#9cebff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10162IconServiceCognitiveServices);
export default __webpack_public_path__ + "static/media/10162-icon-service-Cognitive-Services.d5e477dcf6038ebae6275c46e2a747f0.svg";
export { ForwardRef as ReactComponent };